import {
    ELECTRON_MODE,
    MAX_RETRY_ATTAINT,
    SELF_HOST_MIDDLE_URL,
    WAITING_TIME_BETWEEN_RETRY,
} from "@constants";
import { useMutation } from "@tanstack/react-query";
import { snapshot } from "valtio";

import React, { useEffect } from "react";

import { setMiddlewareApiUrl, store } from "@store";

import { saveMachineIpAddress } from "@helpers/fetcher";
import { getUrlHostname } from "@helpers/general";

import {
    setMachineIpAddress,
    syncStore,
} from "@components/Synchronization/store";

import { setIsNeedToAbortPayment } from "@pages/Kiosk/store";

function UdpServerWrapper({
    children,
}: {
    children: React.ReactNode;
}): JSX.Element {
    const { mutateAsync: handleSaveMachineIp } = useMutation<
        SaveMachineIpResponse,
        Error,
        SaveMachineIpVariables
    >({
        mutationFn: saveMachineIpAddress,
        retry: MAX_RETRY_ATTAINT + 3,
        retryDelay: WAITING_TIME_BETWEEN_RETRY * 2,
        onSuccess: (data) => {
            if (data.code === 2) {
                console.log(
                    "Successfully save machine IP address to setting cloud"
                );
                return;
            } else {
                console.error(
                    `Error while saving machine IP address to setting cloud with data: ${JSON.stringify(
                        data
                    )}`
                );
            }
        },
        onError: (error) => {
            console.error(
                "Catch error on saving machine IP address to setting cloud:",
                error
            );
        },
    });

    useEffect(() => {
        const { selectedShopApp, selectedEntityChild } = snapshot(syncStore);
        const { middlewareApiUrl } = snapshot(store);
        const hostnameUrl = getUrlHostname(middlewareApiUrl);

        if (process.env.REACT_APP_MODE === ELECTRON_MODE) {
            (window as RendererWindow).electronAPI?.onUdpMessage(
                (data: {
                    serverHostName: string;
                    serverIpAddress: string;
                    machineIp: string;
                }) => {
                    const serverHostName =
                        localStorage.getItem("serverHostName");

                    // If no server host name saved in local storage, stop processing UDP message
                    if (serverHostName === null) {
                        console.log(
                            "No server host name saved in local storage"
                        );
                        return;
                    }

                    const { middlewareApiUrl } = snapshot(store);
                    const { machineIpAddress } = snapshot(syncStore);
                    const middleIpAddress = getUrlHostname(middlewareApiUrl);

                    if (data.serverHostName === serverHostName) {
                        if (data.serverIpAddress !== middleIpAddress) {
                            console.log(
                                `setting new ip address  from  old IP Address: ${middleIpAddress} with new ip address from Received UDP message: ${JSON.stringify(
                                    data
                                )}`
                            );

                            //Set Middleware new IP address
                            if (!SELF_HOST_MIDDLE_URL.includes(hostnameUrl)) {
                                setMiddlewareApiUrl(data.serverIpAddress);
                                setIsNeedToAbortPayment(true);
                            }
                        }

                        // update machine IP address
                        if (
                            data.machineIp &&
                            machineIpAddress !== data.machineIp
                        ) {
                            console.log(
                                `setting new machine ip address from old IP Address: ${machineIpAddress} with new ip address from Received UDP message: ${data.machineIp}`
                            );
                            setMachineIpAddress(data.machineIp);
                            if (!SELF_HOST_MIDDLE_URL.includes(hostnameUrl)) {
                                handleSaveMachineIp({
                                    middlewareApiUrl: `http://${data.serverIpAddress}:5001/api/v1`,
                                    franchiseId:
                                        selectedEntityChild?.franchiseUuid as string,
                                    shopId: selectedEntityChild?.uid as string,
                                    appId: selectedShopApp.appId as string,
                                    ip: data.machineIp,
                                });
                            }
                        }
                    }
                }
            );
            return;
        }
    }, []);

    return <>{children}</>;
}

export default UdpServerWrapper;
